export default class Lei {
  constructor(id, codigo, nome, icms, piscofins) {
    this.id = id
    this.codigo = codigo
    this.nome = nome
    this.icms = icms
    this.piscofins = piscofins
  }
}
